export default {
    it: {
        "base_label": "Data",
        "birthday": "Data di nascita",
        "date-error": "Scegli una data",
        "date-ok": ""
        
    },
    en: {
        "base_label": "Date",
        "date-error": "Choose a date",
        "date-ok": "",
        "birthday": "Birthday",
    }
}